import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { action, computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IGlobalConfiguration } from '@kurtosys/ksys-app-components/dist/models/IGlobalConfiguration';
import { IBreakpointProps } from '@kurtosys/ksys-app-components/dist/models/IBreakpointProps';
import { IAppBreakpointProps } from '../models/IAppConfiguration';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
	}

	@computed
	get hasData(): boolean {
		return this.storeContext.barChartStore.hasData;
	}

	@computed
	get globalConfiguration(): IGlobalConfiguration | undefined {
		return this.libraryComponentsConfiguration && this.libraryComponentsConfiguration.global;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get breakpoints(): IBreakpointProps<IAppBreakpointProps>[] | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.breakpoints;
	}

	async customInitializeAfter() {

	}
}